import ClientSuspense from '@components/ClientSuspense'
import Pill from '@components/V3/Pill'
import useIsDarkMode from '@hooks/useIsDarkMode'
import formatNumber from '@i18n/formatNumber'
import useShouldUseLoyaltyV2 from '@page-components/CheckoutV3/sections/useShouldUseLoyaltyV2'
import WebsiteCoinsImage from '@page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage'
import Link from 'next/link'

import useUserInfo from '../hooks/useUserInfo.main'

import WebsiteCoinsSkeleton from './Skeleton'

function InnerWebsiteCoins() {
  const {me, loyaltyProgramConfig} = useUserInfo()
  const showJustoLoyaltyV2 = useShouldUseLoyaltyV2()
  const isDarkMode = useIsDarkMode()

  if (!showJustoLoyaltyV2 || !loyaltyProgramConfig?.active) {
    return null
  }

  return (
    <Pill showCaret={false} className="h-12 !px-1">
      <Link href="/justoloyalty" passHref legacyBehavior>
        <div className="flex px-2 py-1 space-x-1 items-center font-normal">
          <WebsiteCoinsImage svgClass={isDarkMode ? 'secondaryColor' : 'primaryColor'} />
          {!!me?.websiteCoinsBalance && (
            <>
              <span className="hidden md:flex">
                {formatNumber(me.websiteCoinsBalance, 'money', null, true)}
              </span>{' '}
            </>
          )}
          <span className="hidden lg:flex">{loyaltyProgramConfig.name}</span>
        </div>
      </Link>
    </Pill>
  )
}

export default function WebsiteCoins() {
  return (
    <ClientSuspense fallback={<WebsiteCoinsSkeleton />}>
      <InnerWebsiteCoins />
    </ClientSuspense>
  )
}
